import socialClubAPI from '@/app/apis/main/social-club/social-club-api.js';

export default {
	/**
	 * @return {object} members list
	 * @params {queryParams} 
	 * */
	async getGroupMembers(queryParams) {
		return socialClubAPI.getGroupMembers(queryParams);
	},

	/**
	 * @return {object} Club List
	 * @params queryParams
	 * */
	async getGroups(queryParams) {
		return socialClubAPI.getGroups(queryParams);
	},

	/**
	 * @return {object} admin tab reported table list
	 * @param {*} reportedDetails
	 * @param {*} breedId
	 */
	async getAdminReported(breedId, reportedDetails) {
		return socialClubAPI.getAdminReported(breedId, reportedDetails);
	},

	/**
	 * @param {Number} breedId
	 * @param {Number} reportId
	 * @param {String} type - Can be approve or disapprove
	 * */
	async putActionReportedContent(breedId, reportId, type) {
		return socialClubAPI.putActionReportedContent(breedId, reportId, type);
	},

	/**
	 * @param {Number} breedId
	 * @param {Number} customerId
	 * */
	async putMakeAdmin(breedId, customerId) {
		return socialClubAPI.putMakeAdmin(breedId, customerId);
	},

	/**
	 * @param {Number} breedId
	 * @param {Number} customerId
	 * */
	async putRemoveAdmin(breedId, customerId) {
		return socialClubAPI.putRemoveAdmin(breedId, customerId);
	}
}